import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-main', {
        url: '/reports/main',
        component: 'companyLoginReport',
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/company-login-report/company-login-report.state.js